"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isProductOwnedAdapter = _interopRequireDefault(require("self-service-api/adapters/isProductOwnedAdapter"));

var _ProductTierOrders = _interopRequireDefault(require("self-service-api/constants/ProductTierOrders"));

var hasHigherTieredProductAdapter = function hasHigherTieredProductAdapter(productData, parcels, merchandiseId) {
  var tieredProductsGroup = _ProductTierOrders.default.filter(function (productTierOrder) {
    return productTierOrder.indexOf(merchandiseId) !== -1;
  })[0];

  if (!tieredProductsGroup) {
    return false;
  }

  var tierIndex = tieredProductsGroup.indexOf(merchandiseId);
  var higherTieredProductGroups = tieredProductsGroup.slice(tierIndex + 1, tieredProductsGroup.length);
  return higherTieredProductGroups.some(function (tieredMerchandiseId) {
    return (0, _isProductOwnedAdapter.default)(productData, parcels, tieredMerchandiseId);
  });
};

var _default = hasHigherTieredProductAdapter;
exports.default = _default;
module.exports = exports.default;